import styled from "styled-components";
import ContainerInfo from "./ContainerInfo";
import { SkeletonLine } from "../../Componentes/Utils/SkeletonLine";

import { formatarData } from "../../Funcoes/FormatarData"
import { formatCPF } from "../../Funcoes/FormatCPF"

const Container = styled.div`
    width: 520px;
    background-color: #EBEBEB;
    border-radius: 15px;
    box-sizing: border-box;
    padding: 10px;
    overflow: auto;
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE e Edge */
    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari */
    }
`
const MainContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
`
const PicContainer = styled.div`
    width: 225px;
    aspect-ratio: 3 / 4;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 15px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: #f0f0f0;

    & img{
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

`
const SemFoto = styled.div`
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 12px;
    font-weight: bold;
    color: #ACAFB0;
`
const TextsContainer = styled.div`
    width: calc( 100% - 225px );
    display: flex;
    flex-direction: column;
    gap: 10px;
`
const SecondContainer = styled.div`
    margin-top: 10px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px; /* mantém espaçamento como no TextsContainer */
`

const Informacoes = ({ data, loading }) => {
    return (
        <>
            <Container>
                <MainContainer>
                    <PicContainer>
                        {loading ? (
                            <SkeletonLine style={{ width: "100%", height: "100%", borderRadius: 0, margin: 0 }} />
                        ) : data?.IMAGEM ? (
                            <img src={data.IMAGEM} alt="Foto 3x4 do colaborador" />
                        ) : (
                            <SemFoto>SEM FOTO</SemFoto>
                        )}
                    </PicContainer>
                    <TextsContainer>
                        <ContainerInfo loading={loading} title="MATRÍCULA" value={data?.MATRICULA || '-'} />
                        <ContainerInfo loading={loading} title="NOME" value={data?.NOME || '-'} />
                        <ContainerInfo loading={loading} title="CPF" value={data?.CPF ? formatCPF(data.CPF) : "-"} />
                        <ContainerInfo loading={loading} title="CENTRO DE CUSTO" value={data?.CENTRO_CUSTO || '-'} />
                        <ContainerInfo loading={loading} title="FUNÇÃO" value={data?.FUNCAO || '-'} />
                        <ContainerInfo loading={loading} title="SITUAÇÃO" value={data?.STATUS || '-'} />
                    </TextsContainer>
                </MainContainer>
                <SecondContainer>
                    <ContainerInfo loading={loading} title="DATA DE ADMISSÃO" value={data?.ADMISSAO ? formatarData(data.ADMISSAO) : "-"} />
                    <ContainerInfo loading={loading} title="DATA DE DEMISSÃO" value={data?.DEMISSAO ? formatarData(data.DEMISSAO) : "-"} />
                    <ContainerInfo loading={loading} title="MÃO DE OBRA" value={data?.MAO_OBRA || '-'} />
                    <ContainerInfo loading={loading} title="SEXO" value={data?.SEXO || '-'} />
                    <ContainerInfo loading={loading} title="DATA DE NASCIMENTO" value={data?.DATA_NASC ? formatarData( data.DATA_NASC ) : '-'} />
                    <ContainerInfo loading={loading} title="RG" value={data?.RG || '-'} />
                    <ContainerInfo loading={loading} title="UF DO RG" value={data?.RG_UF || '-'} />
                    <ContainerInfo loading={loading} title="MUNICÍPIO DE RESIDÊNCIA" value={ `${ data?.MUNICIPIO }/${ data?.ESTADO }` || '-'} />
                    <ContainerInfo loading={loading} title="PIS" value={data?.PIS || '-'} />
                    <ContainerInfo loading={loading} title="CONTATO" value={
                        data?.TELEFONE
                            ? `${data?.DDDFONE ? `(${data.DDDFONE}) ` : ""}${data.TELEFONE}`
                            : "-"
                    } />
                </SecondContainer>
            </Container>
        </>
    )
}

export default Informacoes;